
const questionModeService = {
    generateAssessmentForSingleQuestion(question) {
        const assessment = {
            assessmentRunTitle: question.title,
            contentItemTitle: question.title,
            title: question.title,
            supportedLanguages: question.supportedLanguages.slice(0),
            defaultLanguage: question.defaultLanguage,
            questionNumbering: question.questionNumbering,
            sections: [
                {
                    id: 1,
                    number: '1',
                    title: 'Section',
                    questions: [
                        question,
                    ],
                },
            ],
        };
        return assessment;
    },
    generateAssessmentForSingleSection(section) {
        const supportedLanguages = section.questions.length > 0 ? section.questions[0].supportedLanguages.slice(0) : ['en_us'];
        const defaultLanguage = section.questions.length > 0 ? section.questions[0].defaultLanguage : 'en_us';
        const assessment = {
            assessmentRunTitle: section.title,
            contentItemTitle: section.title,
            title: section.title,
            questionNumbering: section.questionNumbering,
            supportedLanguages,
            defaultLanguage,
            sections: [
                section,
            ],
        };
        return assessment;
    },
};

export default questionModeService;
